import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import "./Git.css";

function Projects(props) {
    const [projects, setProjects] = useState([]);

    // Not good. Instead, react-query or alternatives should be used.
    // To improve the experience further more, move to SSR.
    useEffect(() => {
        fetch("https://api.github.com/users/Tturna/repos?per_page=100")
        .then((response) => response.json())
        .then((data) => {
            const filtered = data.filter((project) => ["AutoNotifier", "ChatBot21", "Palette-Jam-2", "Shootaman"].includes(project.name))
            setProjects(filtered);
        });
    }, []);

    return (
        <div className="centercontent footermargin">
            <h1>Projects</h1>

            <div className="descarea">
                <div className="descbox">
                    <p>
                        Here are some things that I'm working on and projects that I've done in the past. You can find more about them on
                        my <a href="https://github.com/Tturna" target="_blank" rel="noreferrer">GitHub Page</a>.
                    </p>
                </div>

                <img id="img" src=".\imgs\avatar_yellow_portrait_small.jpg" alt="avatar icon"/>
            </div>

            {/* <h2>Things that I'm working on</h2> */}
            <br></br>

            <div className="tape">
                <div className="page" style={{backgroundImage: "url('./imgs/projects/DistantNeon_U2_variations_U2_blur.jpg')", backgroundPosition: "0 500px"}}>
                    <h2><span>ICT Engineering</span></h2>
                    <h4>I'm currently studying for my Bachelor's degree in <span>ICT</span>. I'm doing <span>Python</span> tutoring for new students.</h4>

                    <NavLink to="/projects/Uni">
                        <div className="learnmore-button">Learn More</div>
                    </NavLink>
                </div>

                <div className="page" style={{backgroundImage: "url('./imgs/concepts/day_blur.jpg')"}}>
                    <h2><span>Game Development</span></h2>
                    <h4>I'm developing a 2D fantasy action-adventure game using <span>Unity</span> and <span>C#</span>.</h4>

                    <NavLink to="/projects/Gamedev">
                        <div className="learnmore-button">Learn More</div>
                    </NavLink>
                </div>
            </div>

            <div className="tape">
                <div className="page" style={{backgroundImage: "url('./imgs/projects/avcc.jpg')", backgroundPosition: "bottom"}}>
                    <h2><span>Arduino Controllers</span></h2>
                    <h4>I use <span>Arduino</span> controllers, <span>Python</span> and Wekinator to control music and effects with body gestures.</h4>

                    <NavLink to="/projects/Avcc">
                        <div className="learnmore-button">Learn More</div>
                    </NavLink>
                </div>

                <div className="page" style={{backgroundImage: "url('./imgs/mainimg.jpg')", backgroundSize: "cover"}}>
                    <h2><span>Web Development</span></h2>
                    <h4>I'm constantly trying to improve my <span>web development</span> skills. Currently I'm improving this portfolio site using <span>React</span>.</h4>

                    <a href="https://github.com/Tturna/portfolio-site-3.0" target="_blank" rel="noreferrer">
                        <div className="learnmore-button">See GitHub</div>
                    </a>
                </div>
            </div>
            
            <h2>Find my work experience on my <a style={{color: "#cc425e"}} href="https://www.linkedin.com/in/roope-juponaho-1a9199156" target="_blank" rel="noreferrer">LinkedIn page</a>.</h2>

            <br></br>

            <div className="beegGit">
                <a href="https://github.com/Tturna" target="_blank" rel="noreferrer">
                    <img id="projectlink" src=".\imgs\socials\github.png" alt="github logo"/>
                </a>
            </div>

            <br></br>

            <h2>Older Projects</h2>

            <br></br>

            {/* <a className="pin br" href="https://github.com/Tturna/ChatBot21" target="_blank" rel="noreferrer">
                <img src=".\imgs\gitpins\chatbot.png" alt="github pin" />
            </a> */}


            {projects.map((project, index) => (
                <div className="pin" key={index}>
                    <a href={project.svn_url} target="_blank" rel="noreferrer">
                        <div className="pincontent">
                            <img className="pinimg" src=".\imgs\socials\github.png" alt="github logo"/>
                            <h2><span>{project.name}</span></h2>
                            <p>{project.description}</p>
                            <p>Made with <span>{project.language}</span></p>
                        </div>
                    </a>
                </div>
            ))}

        </div>
    );
}

export default Projects;